const downloadExcelSheet = async (workbook: any, filename: string) => {
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  const now = new Date();
  const formattedDate = `${String(now.getDate()).padStart(2, '0')}${String(now.getMonth() + 1).padStart(
    2,
    '0',
  )}${now.getFullYear()}`;
  const fullFilename = `${filename}_${formattedDate}.xlsx`;

  exportBlobAsFile(blob, fullFilename);
};

const exportBlobAsFile = (blob: Blob, filename: string) => {
  const a = document.createElement('a');
  const objectUrl = URL.createObjectURL(blob);

  a.href = objectUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();

  URL.revokeObjectURL(objectUrl);
};

export { downloadExcelSheet, exportBlobAsFile };
